var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingMuseum = function SvgBuildingMuseum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M25.313 9.931a.65.65 0 0 0 .351-1.197L13.851 1.141a.65.65 0 0 0-.703 0L1.337 8.734a.65.65 0 0 0 .351 1.197zM2.953 19.406h21.094M1.688 22.781h23.625M.844 26.156h25.312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M10.125 18.563v-6.75l3.375 3.442 3.375-3.443v6.75M21.938 11.813v6.75M5.063 11.813v6.75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 7.594,
    r: 1.688,
    stroke: "currentColor",
    strokeWidth: 1.3
  })));
};
export default SvgBuildingMuseum;